/**
 * Pagination.
 */
const EVENT_AJAX_FINISH = 'mkdoAjaxLoaded';
const EVENT_AJAX_APPEND = 'mkdoAjaxAppend';
const EVENT_SEARCH_AJAX_APPEND = 'mkdoSearchAjaxAppend';

let args = {};

var target = document.querySelector('.grid-layout__inner');

const updateArgs = ( data, callback ) => {
	args = Object.assign( args, data );

	if ( ! args.hasOwnProperty( 'paged' ) ) {
		args.paged = 2;
	} else {
		args.paged++;
	}

	if ( typeof callback === 'function' ) {
		callback();
	}
};

const loadMorePosts = ( url ) => {
	
	const eventFinish = new Event( EVENT_AJAX_FINISH );
	const request     = new XMLHttpRequest();
	const params      = new URLSearchParams();
	let reqUrl        = url;
	const catSelect   = document.getElementById( 'category-select' );	

	params.set( 'posts_per_page', 22 );
	params.set( 'paged', args.paged );	

	if ( reqUrl.includes('search/property') ) {

		params.set( 'property-let-type', args.propertyLetType );
		params.set( 'property-area', args.propertyArea );
		params.set( 'property-price', args.propertyPrice );
		params.set( 'property-bedroom', args.propertyBedroom );
		params.set( 'property-bathroom', args.propertyBathroom );
		params.set( 'property-toilet', args.propertyToilet );
		params.set( 'property-university', args.propertyUniversity );
		params.set( 'property-sort', args.propertySort );
		params.set( 'search-type', 'filter' );
	}

	if ( reqUrl.includes('author') ) {
		params.set( 'authorquery', args.authorquery );
	}

	if ( catSelect && catSelect.value ) {			
		params.set( 'categories', catSelect.value );
	}

	url = new URL( reqUrl );
	if ( ! reqUrl.includes('Search') && ! reqUrl.includes('search')  ) {
		url.href = args.url;
	}
	url.search = params.toString();

	request.open( 'GET', url.href, true );
	request.responseType = 'document';

	request.onreadystatechange = function () {
		if ( request.readyState === XMLHttpRequest.DONE ) {
			document.dispatchEvent( eventFinish );

			if ( request.status !== 200 ) {
				return;
			}

			const _document = request.response;		

			let listings;

			if ( reqUrl.includes('search') ) {
				listings = _document.querySelectorAll( '.listing-div' ); // NodeList.
			} else if ( reqUrl.includes('author') ) {
				listings = _document.querySelectorAll( '.listing-article' ); // NodeList.
			} else {
				listings = _document.querySelectorAll( '.listing-blog' ); // NodeList.					
			}

			let appendEvent;

			if ( _document.querySelector( '.grid-layout__inner' ) ) {
				appendEvent = EVENT_SEARCH_AJAX_APPEND;
			}

			if ( ! listings || ! listings.length ) {
				return;
			}

			const eventAppend = new CustomEvent(
				appendEvent,
				{
					detail: {
						items: listings,
					}
				}
			);

			document.dispatchEvent( eventAppend );
		}
	};

	request.send();

};

export function blogNavigationInit() {
	const navigation  = document.querySelector( '.navigation' );
	const blogOrAuthor = document.querySelector( 'body.blog, body.author' );

	if ( ! blogOrAuthor || ! navigation ) {
		return;
	}

	const loadMore    = navigation.querySelector( '.navigation__loader' );
	const loadMoreBtn = loadMore.querySelector( '.navigation__load-more' );

	// Bind events.
	loadMoreBtn.addEventListener( 'click', function ( event ) {
		event.preventDefault();

		if ( ! this.dataset.hasOwnProperty( 'url' ) ) {
			return;
		}

		updateArgs( this.dataset, () => {
			if ( args.paged >= args.max_num_pages ) {
				loadMoreBtn.remove();
			} else {
				loadMoreBtn.classList.add( 'pp-button--loading' );
			}

			loadMorePosts( this.dataset.url );
		} );
	} );

	document.addEventListener( EVENT_AJAX_FINISH, function () {
		loadMoreBtn.classList.remove( 'pp-button--loading' );
		checkDOMUpdates();
	} );
};

export function searchNavigationInit() {
	const searchResults = document.querySelector( '.search-results' );
	const navigation = document.querySelector( '.navigation' );

	if ( ! searchResults || ! navigation ) {
		return;
	}

	const loadMore    = navigation.querySelector( '.navigation__loader' );
	const loadMoreBtn = loadMore.querySelector( '.navigation__load-more' );

	// Bind events.
	loadMoreBtn.addEventListener( 'click', function ( event ) {
		event.preventDefault();

		updateArgs( this.dataset, () => {
			if ( args.paged >= args.max_num_pages ) {
				loadMoreBtn.remove();
			} else {
				loadMoreBtn.classList.add( 'pp-button--loading' );
			}

			loadMorePosts( window.location.href );
		} );
	} );

	document.addEventListener( EVENT_AJAX_FINISH, function () {
		loadMoreBtn.classList.remove( 'pp-button--loading' );
		checkDOMUpdates();
	} );
};

export function propertyNavigationInit() {	
	const navigation = document.querySelector( '.navigation' );
	const page = document.querySelector ( 'body.page' );

	if ( ! navigation || ! page ) {
		return;
	}

	const loadMore    = navigation.querySelector( '.navigation__loader' );
	const loadMoreBtn = loadMore.querySelector( '.navigation__load-more' );

	// Bind events.
	loadMoreBtn.addEventListener( 'click', function ( event ) {
		event.preventDefault();

		if ( ! this.dataset.hasOwnProperty( 'url' ) ) {
			return;
		}

		updateArgs( this.dataset, () => {
			if ( args.paged >= args.max_num_pages ) {
				loadMoreBtn.remove();
			} else {
				loadMoreBtn.classList.add( 'pp-button--loading' );
			}

			loadMorePosts( window.location.href );
		} );
	} );

	document.addEventListener( EVENT_AJAX_FINISH, function () {
		loadMoreBtn.classList.remove( 'pp-button--loading' );
		checkDOMUpdates();
	} );
};


function checkDOMUpdates() {

	if ( ! observer ) {
		var i = target.getElementsByClassName('datalayer-property').length - 1;	// Ensure following dataLayer index schema (IE: ensure first instance is 0)
	}

	let observer = new MutationObserver(function (mutations) {
		mutations.forEach(function(mutation) {

			if ( mutation.addedNodes[0].classList.contains('datalayer-property') )  {
				i++;

				var dataLayerItemId = mutation.addedNodes[0].getAttribute('datalayer-item_id');
				var dataLayerItemName = mutation.addedNodes[0].getAttribute('datalayer-item_name');			
				var dataLayerItemCategory1 = mutation.addedNodes[0].getAttribute('datalayer-category');
				var dataLayerItemCategory2 = mutation.addedNodes[0].getAttribute('datalayer-category_2');
				var dataLayerItemCategory3 = mutation.addedNodes[0].getAttribute('datalayer-category_3');
				var dataLayerItemListId = mutation.addedNodes[0].getAttribute('datalayer-item_list_id');
				var dataLayerItemListName = mutation.addedNodes[0].getAttribute('datalayer-item_list_name');
				var dataLayerItemVariant = mutation.addedNodes[0].getAttribute('datalayer-item_variant');
				var dataLayerPrice = mutation.addedNodes[0].getAttribute('datalayer-price');
				var dataLayerQuantity = mutation.addedNodes[0].getAttribute('datalayer-quantity');

				mutation.addedNodes[0].querySelector('a').addEventListener('click', function() {									
					window.dataLayer.push({
						"event": "select_item",
						"ecommerce": {
							"item_list_id": dataLayerItemListId,
							"item_list_name": dataLayerItemListName,
							"items": [
								{
									"item_id": dataLayerItemId,
									"item_name": dataLayerItemName,
									"index": i,
									"item_category": dataLayerItemCategory1,
									"item_category_2": dataLayerItemCategory2,
									"item_category_3": dataLayerItemCategory3,
									"item_list_id": dataLayerItemListId,
									"item_list_name": dataLayerItemListName,
									"item_variant": dataLayerItemVariant,
									"price": dataLayerPrice,
									"quantity": dataLayerQuantity,
								}
							],
						}
					});		
				});
		
			}
				
		});
	});

	observer.observe(target, {
		attributes: true,
		childList: true,
		characterData: true,
	});
}

